var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3927 4.66699L7.99935 7.06033L5.60602 4.66699L4.66602 5.60699L7.05935 8.00033L4.66602 10.3937L5.60602 11.3337L7.99935 8.94033L10.3927 11.3337L11.3327 10.3937L8.93935 8.00033L11.3327 5.60699L10.3927 4.66699Z",
    fill: "#F17676"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXMark);
export default __webpack_public_path__ + "static/media/x_mark.8c92a4860466c137497b6c3ad7b3466f.svg";
export { ForwardRef as ReactComponent };